import React from 'react';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';

class Boxplot extends React.Component {
    _onClick(output) {
        //this.props.onSubmit()
        this.props.onSubmit(output)
    }

    
    render() {
        const output = "NA"

        return (
            <div>
                <div>
                <h2><strong>Chose Options</strong></h2>
                <Box direction='row'
                        justify='center'
                        align='center'
                        wrap={true}
                        reverse={false}
                        margin='none'>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            NA
                        </Box>
                    </Box>
                <Button label='Submit'
            type='submit'
            primary={true}
            onClick={this._onClick.bind(this, output)} />
                </div> 
            </div>  
        );
    }
}

export default Boxplot;



// WEBPACK FOOTER //
// ./src/samples/options/boxplotoptions.js